import {DEEP_LINK} from '../actions/types';

const INITIAL_STATE = {
  deepLinkType: '',
  deepLinkId: ['', ''],
  deepLinkQrCode: '',
};

const DeepLink = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DEEP_LINK:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default DeepLink;
